/**
 * Экран, которому нужен аккаунт, в режиме просмотра.
 *
 * Вместо ошибки авторизации — объяснение и одна кнопка: человек пришёл
 * с сайта, и «401» ничего ему не скажет.
 */
import { config } from '@/shared/config/env';
import { botStartUrl } from '@/shared/lib/guest';
import { openExternal } from '@/shared/lib/links';
import { Button } from '@/shared/ui/kit/Button';
import { Icon, type IconName } from '@/shared/ui/kit/Icon';

import styles from './Guest.module.css';

interface Props {
  icon: IconName;
  title: string;
  text: string;
}

export function GuestNotice({ icon, title, text }: Props) {
  return (
    <section className={styles.notice}>
      <span className={styles.badge} aria-hidden>
        <Icon name={icon} size={30} />
      </span>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.text}>{text}</p>
      <Button block onClick={() => openExternal(botStartUrl)}>
        Войти через @{config.botUsername}
      </Button>
    </section>
  );
}
